import React from "react";
import data from "../../json/Allservices/Technology.json";
import CustomButtonLink from "../buttonComponent";

const Section1 = () => {
  return (

    <div className="w-full flex justify-center bg-cover bg-center bg-no-repeat bg-techbg sm:min-h-[80vh] min-h-[70vh] ">
      <div className="2xl:container w-full py-10 h-full md:px-10 lg:px-20  px-6 flex items-center justify-center md:justify-start md:py-20 sm:min-h-[80vh] min-h-[70vh] ">
        <div className={`flex flex-col w-full lg:w-[80%] xl:w-[60%] gap-5 text-center md:text-left`}>
            <h1 className="text-24 min-[450px]:text-28 sm:text-32 md:text-40 lg:text-48 text-white font-bold"> {data.heading}</h1>
            <p className="text-14 sm:text-16 lg:text-18 text-lightwhite opacity-90">
              {data.desc}
            </p>
            <div className="mt-7">
            <CustomButtonLink to={"/company/contactus"} label={"Get Started Now"} />
            </div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
